async function likesConstructor({ ActionData = 'get', TargetId, Data }) {
    let uri = 'https://' + this.ServerUrl + `/likesConstructor?sessionId=${this.lastSessionId}`;
    if (Data) uri += '&Data=' + JSON.stringify(Data);
    if (ActionData) uri += '&ActionData=' + ActionData;
    if (TargetId) uri += '&TargetId=' + TargetId;

    const answer = await this.standartDataResult(uri, { timeout: 1500 });
    if (!answer.error) {
        return answer.result;
    }
    return [];
}

export default {
    likesConstructor
}